import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { menuData } from './menuData';
import './navigation.scss';
import { CloseXIcon } from '../../../../UI/Icons/Icons';

export class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.sortCats = this.sortCats.bind(this);
  }

  componentDidMount() {
    this.props.NavMegaMenuData();
  }

  adaskipNavigation() {
    $('.header_promo').focus().css('outline-color', 'transparent');
  }

  formatURLsIfNeeded(href) {
    if (href.indexOf('dillards.com') > -1) {
      href = href.split('dillards.com')[1];
    }
    return href;
  }
  sortCats(property) {
    var sortOrder = 1;
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  render() {
    var megaMenuData = this.props.megaMenuState.superCats || menuData.sort(this.sortCats('value'));
    var display = this.props.megaMenuState.display == 'Just For You';
    return (
      <React.Fragment>
        <nav id='menu_wrapper'>
          {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
            <div id='backgroundContainer' className='container-fluid p-0'>
              <div
                id='main_nav'
                onMouseOver={() => this.props.onMouseOver()}
                onMouseOut={() => this.props.onMouseOut()}
              >
                <ul className='menu'>
                  {megaMenuData.map((supercat, i) => (
                    <li
                      key={i}
                      className={
                        supercat?.display == 'Beauty' || supercat?.display == 'Just For You'
                          ? 'hide-when-international'
                          : ''
                      }
                    >
                      <Link
                        to={this.formatURLsIfNeeded(supercat?.link)}
                        id={`topcat_${supercat?.display.split(' ').join('-').split("'").join('')}`}
                        className={`topCatLink`}
                        manual_cm_sp={supercat?.manual_cm_sp || null}
                        data-supername={supercat?.display}
                        onKeyDown={this.props.handleKeyPress}
                        onMouseOver={this.props.handleSelectedMenuState}
                        onClick={this.adaskipNavigation}
                      >
                        {supercat?.display}
                      </Link>
                      {(supercat.columns != undefined || supercat.columns != null) &&
                      supercat.display != 'Just For You' ? (
                        <button
                          className='hiddenButtonForNav'
                          data-supername={supercat?.display}
                          onClick={this.props.toggleMenu}
                          role='button'
                          aria-controls='mega-menu-wrapper'
                          aria-expanded='false'
                          aria-label={supercat?.display}
                        ></button>
                      ) : (
                        ''
                      )}
                    </li>
                  ))}
                </ul>
                {this.props.getSelectedMenuState.columns == undefined ||
                this.props.getSelectedMenuState.columns == null ? (
                  ''
                ) : (
                  <Menu
                    megaMenuState={this.props.getSelectedMenuState}
                    menuHoverIntent={this.props.menuOpen}
                    formatURLsIfNeeded={this.formatURLsIfNeeded}
                    passedAppFunctions={this.props.passedAppFunctions}
                    closeMenu={this.props.closeMenu}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className='container'>
              <div id='main_nav'>
                <ul className='menu'>
                  {megaMenuData.map((supercat, i) => (
                    <li
                      key={i}
                      className={`${supercat?.display == 'Beauty' || supercat?.display == 'Just For You' ? 'hide-when-international' : ''}`}
                    >
                      <Link
                        to={this.formatURLsIfNeeded(supercat?.link)}
                        id={`topcat_${supercat?.display.split(' ').join('-').split("'").join('')}`}
                        className={`topCatLink`}
                        manual_cm_sp={supercat?.manual_cm_sp || null}
                        data-supername={supercat?.display}
                        onTouchStart={this.props.handleSelectedMenuState}
                        onTouchEnd={this.props.checkIt}
                        onClick={this.adaskipNavigation}
                      >
                        {supercat?.display}
                      </Link>
                    </li>
                  ))}
                </ul>
                {this.props.getSelectedMenuState.columns == undefined ||
                this.props.getSelectedMenuState.columns == null ? (
                  ''
                ) : (
                  <Menu
                    megaMenuState={this.props.getSelectedMenuState}
                    menuHoverIntent={this.props.menuOpen}
                    formatURLsIfNeeded={this.formatURLsIfNeeded}
                    passedAppFunctions={this.props.passedAppFunctions}
                    closeTabletMenu={this.props.closeTabletMenu}
                    closeMenu={this.props.closeMenu}
                  />
                )}
              </div>
            </div>
          )}
        </nav>
        {this.props.menuOpen && this.props.passedAppFunctions.siteFormat === 'tablet' && display === 'Just For You' ? (
          <div className='TabletMenu__backdrop' onClick={this.props.closeTabletMenu}></div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}

export class Menu extends Component {
  render() {
    var columns = this.props.megaMenuState.columns;
    const iscolumnsPresent = this.props.megaMenuState.columns.length != 0;
    return (
      <>
        {iscolumnsPresent ? (
          <section
            className={classnames('mega-menu-wrapper', {
              'mega-menu-wrapper-open': this.props.menuHoverIntent,
            })}
            data-menucat=''
          >
            {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
              <div className='megaMenuCloseWrapper'>
                <button className='megaMenuClose close btn-tertiary' type='button' onClick={this.props.closeMenu}>
                  <CloseXIcon />
                </button>
              </div>
            ) : (
              ''
            )}
            <div className='row mx-0'>
              {columns?.map((element, outerCount) => (
                <div className='col' key={outerCount}>
                  {element.groupings.map((value, i) => (
                    <React.Fragment key={i}>
                      <h2 className='menuCat'>
                        {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
                          value.link == '' ? (
                            value.display
                          ) : (
                            <Link
                              to={this.props.formatURLsIfNeeded(value.link)}
                              manual_cm_sp={value.manual_cm_sp}
                              onClick={this.props.closeMenu}
                            >
                              {value.display}
                            </Link>
                          )
                        ) : value.link == '' ? (
                          value.display
                        ) : (
                          <Link
                            to={this.props.formatURLsIfNeeded(value.link)}
                            manual_cm_sp={value.manual_cm_sp}
                            onClick={this.props.closeTabletMenu}
                          >
                            {value.display}
                          </Link>
                        )}
                      </h2>
                      <ul className='children' key={value.display + value.manual_cm_sp}>
                        {value.items.map((item, i) => (
                          <li key={i + item.display}>
                            <Link
                              to={this.props.formatURLsIfNeeded(item.link)}
                              className={`topCatSubLink`}
                              manual_cm_sp={item.manual_cm_sp}
                              onClick={this.props.closeMenu}
                            >
                              {item.display}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  ))}
                </div>
              ))}
            </div>
          </section>
        ) : (
          ''
        )}
      </>
    );
  }
}

export default Navigation;
